// extracted by mini-css-extract-plugin
export default {"topbar":"syncfusion_topbar__jJ7OY","button":"syncfusion_button__Uv8XI","editorContainer":"syncfusion_editorContainer__0eu27"};